const config = {
  region: process.env.REACT_APP_REGION || 'us-east-2',
  userPoolId: process.env.REACT_APP_USER_POOL_ID,
  userPoolClientId: process.env.REACT_APP_USER_POOL_CLIENT_ID,
  apiUrl: process.env.REACT_APP_API_URL || '',
  notesBucket: process.env.REACT_APP_NOTES_BUCKET,
};
export default config;